import Logger from '../../utils/logger';

export function requestFullscreen(el, video) {
  if (!el) return;

  const methods = [
    'requestFullscreen',
    'mozRequestFullscreen',
    'msRequestFullscreen',
    'webkitRequestFullscreen',
  ];

  for (const method of methods) {
    if (method in el && typeof el[method] === 'function') {
      const returnPromise = el[method]();

      if (returnPromise instanceof Promise) {
        returnPromise.catch((err) => {
          Logger.error(`Error attempting to enable fullscreen mode: ${err.message} (${err.name})`);
        });
      }
      return;
    }
  }
  // on iOS only video element can become fullscreen
  if (video?.webkitSupportsFullscreen) {
    video.webkitEnterFullscreen();
  }
}

export function exitFullscreen(video) {
  const methods = [
    'exitFullscreen',
    'mozCancelFullScreen',
    'msExitFullscreen',
    'webkitExitFullscreen',
  ];

  for (const method of methods) {
    if (method in document && typeof document[method] === 'function') {
      const returnPromise = document[method]();

      if (returnPromise instanceof Promise) {
        returnPromise.catch((err) => {
          Logger.error(`Error attempting to disable fullscreen mode: ${err.message} (${err.name})`);
        });
      }
      return;
    }
  }

  if (video) {
    // on iOS exit full screen should be done on video element
    for (const method of methods) {
      if (method in video && typeof video[method] === 'function') {
        const returnPromise = video[method]();

        if (returnPromise instanceof Promise) {
          returnPromise.catch((err) => {
            Logger.error(`Error attempting to disable fullscreen mode: ${err.message} (${err.name})`);
          });
        }
        return;
      }
    }
  }
}

export function isFullScreenMode() {
  const props = [
    'fullscreenElement',
    'mozFullScreenElement',
    'msFullscreenElement',
    'webkitFullscreenElement',
    'webkitCurrentFullScreenElement',
  ];

  for (const prop of props) {
    if (prop in document) {
      return Boolean(document[prop]);
    }
  }

  return false;
}

export function toggleFullScreen(el, video, isFullScreen) {
  if (isFullScreen) {
    exitFullscreen(video);
  } else {
    requestFullscreen(el, video);
  }
}

const documentEvents = [
  'webkitfullscreenchange',
  'mozfullscreenchange',
  'fullscreenchange',
  'MSFullscreenChange',
];
const elementEvents = [
  'webkitbeginfullscreen',
  'webkitendfullscreen',
];

export function onFullScreenChange(element, cb) {
  for (const event of documentEvents) {
    document.addEventListener(event, cb);
  }
  if (element) {
    for (const event of elementEvents) {
      element.addEventListener(event, cb);
    }
  }
}

export function offFullScreenChange(element, cb) {
  for (const event of documentEvents) {
    document.removeEventListener(event, cb);
  }
  if (element) {
    for (const event of elementEvents) {
      element.removeEventListener(event, cb);
    }
  }
}
